/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EditalIdRouteImport } from './routes/edital/$id'
import { Route as EditaisContratacaoIndexRouteImport } from './routes/editais/contratacao/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const EditalIdRoute = EditalIdRouteImport.update({
  id: '/edital/$id',
  path: '/edital/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const EditaisContratacaoIndexRoute = EditaisContratacaoIndexRouteImport.update({
  id: '/editais/contratacao/',
  path: '/editais/contratacao/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/edital/$id': typeof EditalIdRoute
  '/editais/contratacao/': typeof EditaisContratacaoIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/edital/$id': typeof EditalIdRoute
  '/editais/contratacao': typeof EditaisContratacaoIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/edital/$id': typeof EditalIdRoute
  '/editais/contratacao/': typeof EditaisContratacaoIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/edital/$id' | '/editais/contratacao/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/edital/$id' | '/editais/contratacao'
  id: '__root__' | '/' | '/edital/$id' | '/editais/contratacao/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  EditalIdRoute: typeof EditalIdRoute
  EditaisContratacaoIndexRoute: typeof EditaisContratacaoIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/edital/$id': {
      id: '/edital/$id'
      path: '/edital/$id'
      fullPath: '/edital/$id'
      preLoaderRoute: typeof EditalIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/editais/contratacao/': {
      id: '/editais/contratacao/'
      path: '/editais/contratacao'
      fullPath: '/editais/contratacao/'
      preLoaderRoute: typeof EditaisContratacaoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  EditalIdRoute: EditalIdRoute,
  EditaisContratacaoIndexRoute: EditaisContratacaoIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
